import { Component } from 'react';
import AreaIcon from 'legacy/javascripts/components/area_icon.es6.jsx';

class AreaOfImprovement extends Component {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  onClick(id, name) {
    this.props.chartHandler({
      filters: { response_tag_ids: id },
      mixpanelId: 'areasOfImprovement',
    });

    const areaPerMemberTable = document.querySelector('.js-team-area-drill');
    if (areaPerMemberTable !== null) {
      areaPerMemberTable.querySelector(`.tab[data-tab-name="${name}"]`).click();
      areaPerMemberTable.querySelector(`[data-column-key="${name}"]`).click();
    }
  }

  render() {
    let areaNameStyle = {
      textAlign: 'center',
      margin: '8px 0',
      fontSize: '30px',
    };
    let { id, value, name, icon } = this.props;
    return (
      <div
        className="areaOfImprovement"
        data-active={value !== 0}
        onClick={() => this.onClick(id, name)}
        data-target=".js-team-area-drill"
        data-toggle="modal"
      >
        <AreaIcon cursor="pointer" icon={icon} />
        <div data-notranslate>{name}</div>
        <h3 style={areaNameStyle} className={`spec-area-${name}`}>
          {value !== 0 ? value : '–'}
        </h3>
      </div>
    );
  }
}

export default AreaOfImprovement;
